import bmr from "./bmr/theme";
import { createTheme } from "@mui/material/styles";

export const modeTheme = (mode) => {
  const palettes = bmr;
  return createTheme({
    deck: {
      easy: { main: "#2e7d32" },
      normal: { main: "#0288d1" },
      hard: { main: "#d32f2f" },
    },
    palette: {
      mode: mode,
      ...(mode === "dark" ? palettes.dark : palettes.light),
    },
  });
};
